import React from 'react';

const Terms = () => {
  return (
    <div className="terms-page">
      <h1>Terms of Service</h1>
      <p>Read our terms and conditions</p>
    </div>
  );
};

export default Terms;